import { Map } from 'immutable';
import * as Redux from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { Persistor, persistStore, persistReducer } from 'redux-persist';
import ThunkMiddleware from 'redux-thunk';

import { ReduxLogger } from '../libs/IdeLink.Web.Common/src/services/logger/ReduxLogger';

import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

import { I18nState } from '../libs/IdeLink.Web.Common/src/services/i18n/I18nMessages';
import { AuthenticationMiddleware } from '../libs/IdeLink.Web.Common/src/modules/Auth/Services/Authentication/Base/AuthenticationMiddleware';
import { UserMiddleware } from '../libs/IdeLink.Web.Common/src/modules/User/UserMiddleware';
import { PermissionsMiddleware } from './services/permissions/permissionsMiddleware';
import { LoginMethod } from '../libs/IdeLink.Web.Common/src/modules/Auth/Services/Authentication/AuthenticationConstants';
import { AppReducers } from '../libs/IdeLink.Web.Common/src/app/AppState';
import { RouterReducer } from '../libs/IdeLink.Web.Common/src/redux/BrowserHistory';
import { I18nReducer } from '../libs/IdeLink.Web.Common/src/services/i18n/I18nReducer';
import { AuthenticationReducer } from '../libs/IdeLink.Web.Common/src/modules/Auth/Services/Authentication/Base/AuthenticationReducer';
import { UserReducer } from '../libs/IdeLink.Web.Common/src/modules/User/UserReducer';
import { PermissionsReducer } from './services/permissions/permissionsReducer';

const immutableTransform = require('redux-persist-transform-immutable');

export interface GetIdelinkStoreParams {
    authStorageKey: string;
    loginMethod: LoginMethod;
    I18n: I18nState;
}

export class IdelinkStore {
    public static getStore = ({ authStorageKey, loginMethod, I18n }: GetIdelinkStoreParams) => {
        const middlewares = ReduxLogger.withMiddlewares([
            ThunkMiddleware,
            PermissionsMiddleware,
            AuthenticationMiddleware,
            UserMiddleware,
        ]);
        const rawAppReducer = combineReducers<AppReducers>({
            router: RouterReducer,
            I18n: I18nReducer,
            Authentication: AuthenticationReducer,
            User: UserReducer,
            Permissions: PermissionsReducer,
        });

        const applicationReducer = persistReducer(
            {
                key: authStorageKey,
                whitelist: ['Authentication', 'User', 'Permissions'],
                transforms: [immutableTransform()],
                storage,
            },
            rawAppReducer
        );

        const composeEnhancers = composeWithDevTools({});
        const enhancer: Redux.StoreEnhancer = composeEnhancers(
            Redux.applyMiddleware(...middlewares)
        );

        const initialState: Partial<AppReducers> = { Authentication: Map({ loginMethod }), I18n };
        const store: Redux.Store = Redux.createStore(applicationReducer, initialState, enhancer);
        const persistor: Persistor = persistStore(store);
        return { store, persistor };
    };
}
